'use client';

import { useId, useState } from 'react';
import { ArrowRight, ArrowUpRight } from '@phosphor-icons/react';
import { PhoneIcon, PlusIcon } from '@/components/icons';
import './delivery-help.css';

const questions = [
  {
    label: 'Когда приедет заказ',
    title: 'Время зависит от адреса',
    text: 'Ориентир появится после проверки адреса. Время считаем с подтверждения заказа: на него влияют загрузка кухни, погода и движение на дорогах. Более точный ориентир подскажет оператор.',
    action: 'Проверить адрес',
    href: '#delivery',
  },
  {
    label: 'Доставка ко времени',
    title: 'Выберите удобный интервал',
    text: 'При оформлении заказа выберите доставку ко времени. Доступные даты и интервалы появятся в корзине — останется выбрать подходящий.',
    action: 'Перейти к меню',
    href: '/#menu',
  },
  {
    label: 'Адрес за границей зоны',
    title: 'Уточним возможные варианты',
    text: 'Доставляем в пределах зон на карте. За её пределами возможна доставка за счёт клиента через Яндекс Доставку. Позвоните нам до оформления — обсудим условия для вашего адреса.',
  },
  {
    label: 'Связаться с курьером',
    title: 'Оператор поможет с заказом',
    text: 'Если плановое время ещё не истекло, стараемся не отвлекать курьера от дороги. Позвоните нам — оператор проверит статус. Если заказ везёт Яндекс Доставка, отправим СМС для отслеживания в Яндекс Go.',
  },
  {
    label: 'Заказ задерживается',
    title: 'Узнаем, где ваш заказ',
    text: 'Позвоните нам и сообщите о задержке. Оператор уточнит, где заказ, и сориентирует по времени. Если мы опоздали с приготовлением или доставкой, сделаем комплимент от компании.',
  },
  {
    label: 'Не хватает блюда',
    title: 'Поможем всё исправить',
    text: 'Обратитесь на горячую линию в течение часа. Привезём недостающее блюдо в ближайшее время или предложим компенсацию.',
  },
];

export function DeliveryHelp({ phone }: { phone: string }) {
  const [selected, setSelected] = useState(0);
  const id = useId();
  const question = questions[selected];
  const tel = `tel:${phone.replace(/[^+\d]/g, '')}`;
  return (
    <section className="delivery-help" aria-labelledby={`${id}-title`}>
      <div className="delivery-help-heading">
        <h2 id={`${id}-title`}>Вопросы о доставке</h2>
        <a href={tel}>
          <PhoneIcon size={17} />
          <span>{phone}</span>
          <ArrowUpRight size={16} />
        </a>
      </div>
      <div className="delivery-help-desktop">
        <div
          className="delivery-help-topics"
          role="tablist"
          aria-label="Темы вопросов"
          aria-orientation="vertical"
        >
          {questions.map((item, index) => (
            <button
              key={item.label}
              type="button"
              role="tab"
              id={`${id}-tab-${index}`}
              aria-selected={selected === index}
              aria-controls={`${id}-answer`}
              tabIndex={selected === index ? 0 : -1}
              onClick={() => setSelected(index)}
              onKeyDown={(event) => {
                const moves: Record<string, number> = {
                  ArrowDown: (index + 1) % questions.length,
                  ArrowUp: (index - 1 + questions.length) % questions.length,
                  Home: 0,
                  End: questions.length - 1,
                };
                const next = moves[event.key];
                if (next === undefined) return;
                event.preventDefault();
                setSelected(next);
                document.getElementById(`${id}-tab-${next}`)?.focus();
              }}
            >
              <span>{item.label}</span>
              <ArrowUpRight size={20} />
            </button>
          ))}
        </div>
        <div
          className="delivery-help-answer"
          id={`${id}-answer`}
          role="tabpanel"
          aria-labelledby={`${id}-tab-${selected}`}
          tabIndex={0}
        >
          <span className="delivery-help-answer-label">Азиаточка · поддержка</span>
          <h3>{question.title}</h3>
          <p>{question.text}</p>
          <a href={question.href ?? tel}>
            {question.action ?? 'Позвонить нам'} <ArrowRight size={20} />
          </a>
        </div>
      </div>
      <div className="delivery-help-mobile">
        {questions.map((item) => (
          <details className="delivery-help-detail" key={item.label}>
            <summary>
              {item.label}
              <PlusIcon size={19} />
            </summary>
            <div>
              <h3>{item.title}</h3>
              <p>{item.text}</p>
              <a href={item.href ?? tel}>
                {item.action ?? 'Позвонить нам'} <ArrowUpRight size={17} />
              </a>
            </div>
          </details>
        ))}
      </div>
    </section>
  );
}
